import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import {
  Box,
  Button,
  Checkbox,
  // CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Select,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  ListItemIcon,
  ListItemText,
  TableRow,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import { GetTimeZone, getWorkonDate } from "../../_utilities/GetTimeZone";
import { DashboardPlusicon } from "../../Icons/DashboardPlusicon";
import { InfoIcon } from "../../Icons/InfoIcon";
import "./DynamicTableStyle.css";
import Pagination from "./Pagination";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StarIcon from "@mui/icons-material/Star";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const warningPopupEnum = {
  DELETE: {
    title: "Are you sure you want to delete ?",
    btnName: "Delete",
    type: "confirmDel",
  },
  CLONE: {
    title: "Are you sure you want to clone ?",
    btnName: "Yes",
    type: "confirmClone",
  },
  DEACTIVATE: {
    title: "Are you sure you want to deactivate ?",
    btnName: "Deactivate",
    type: "deactivate",
  },
  REACTIVATE: {
    title: "Are you sure you want to reactivate ?",
    btnName: "Reactivate",
    type: "reactivate",
  },
};

const DynamicTable = ({
  config,
  data,
  colmns,
  actionDropdown,
  filterValue,
  actions,
  noDataText,
  onReceiveActionProps,
  searchKeyWord,
  addModel,
  statusValues,
  selectedId,
  tableMaxheight = "auto",
  sendSelectedIds = false,
}) => {
  const [tableData, setTableData] = useState(data);
  const [checked, setChecked] = useState(false);
  const defaultActionLabel = config.defaultActionValue || "Action";
  const [action, setAction] = useState(defaultActionLabel);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState(filterValue);
  const [isInterminate, setIsInterminate] = useState(false);
  const tableRawData = JSON.stringify(data);
  const currentPage = config.currentPage;
  const showLoader = useSelector((state) => state.Loader.value);
  const showUncommonLoader = useSelector((state) => state.UncommonLoader.value);
  const [open, setOpen] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    btnName: "",
    type: "",
  });
  const [appTheme, setTheme] = useState({});

  const handleClose = () => {
    setOpen(false);
    setDeleteId(null);
    setAction(defaultActionLabel);
  };

  const usersPerPage = config.recordperPage;
  const [totalRecords, setTotalRecords] = useState(config.totalRecords);
  const [totalRecordsCount, setTotalRecordsCount] = useState(
    config.totalRecordsCount,
  );
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const filteropen = Boolean(anchorEl);
  const [anchorMuiltipleActionEl, setAnchorMuiltipleActionEl] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handlefilterClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("themeSettings");
    if (storedTheme) {
      setTheme(JSON.parse(storedTheme));
    }
  }, []);

  useEffect(() => {
    if (sendSelectedIds) {
      onSelectActionHandler("Delete");
    }
  }, [sendSelectedIds]);

  useEffect(() => {
    setTableData(data);
    if (data.length && data && data !== "null") {
      let filterData = data.filter((x) => x.isChecked === true);
      if (filterData.length === data.length) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [data, config]);

  const isTableLoading = showLoader || showUncommonLoader;

  useEffect(() => {
    if (
      !isTableLoading &&
      (tableData === "null" ||
        (Array.isArray(tableData) && tableData.length === 0))
    ) {
      setShowNoData(true);
    } else {
      setShowNoData(false);
    }
  }, [tableData, isTableLoading]);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor:
        theme.palette.mode === "light" ? "var(--primary-bg-color)" : "#308fe8",
    },
  }));

  const onCheckedHandler = (e, displayUser) => {
    const data = JSON.parse(JSON.stringify(tableData));
    let index = data.findIndex((x) => x.id === displayUser.id);
    if (index !== -1) {
      data[index].isChecked = !data[index].isChecked;
      setTableData(data);
      isSelectAll("individual", e.target.checked, data);
      onReceiveActionProps(
        "selectedRows",
        data.filter((x) => x.isChecked),
      );
    }
  };

  useEffect(() => {
    setTotalRecords(config.totalRecords);
    setTotalRecordsCount(config.totalRecordsCount);
    if (config.isPagingServer === false && !searchValue) {
      setTableData(
        data.slice(
          (config.currentPage - 1) * usersPerPage,
          config.currentPage * usersPerPage,
        ),
      );
    } else if (
      config.isPagingServer === false &&
      config.isSearchServer === false &&
      searchValue !== "" &&
      searchValue?.length >= 2
    ) {
      onSearchhandler(searchValue, "onRequestSearch");
    }
  }, [config]);

  useEffect(() => {
    isSelectAll("all", null, null);
  }, [checked]);

  useEffect(() => {
    setSearchValue(filterValue);
  }, [filterValue]);

  const isSelectAll = (type, boolean, data) => {
    if (type === "all") {
      setIsInterminate(false);
    } else if (type === "individual") {
      setChecked(false);
    } else {
      let filterData = data.filter((x) => x.isChecked === boolean);
      if (filterData.length === data.length) {
        setIsInterminate(false);
      } else {
        setIsInterminate(true);
      }
    }
  };

  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    let Data = tableData;
    Data.forEach((item) => {
      item.isChecked = isChecked;
      if (item.length <= 1) {
        setIsInterminate(false);
      }
    });
    setTableData(Data);
    onReceiveActionProps(
      "selectedRows",
      Data.filter((x) => x.isChecked),
    );
  };

  const onSearchhandler = (value, type) => {
    if (value !== "" && type !== "onChange") {
      value = value?.trimStart();
      setSearchValue(value);
      if (config.isSearchServer === true) {
        if (value !== "" && value.length >= 2) {
          let obj1 = {
            current:
              config.currentPage !== 1
                ? (config.currentPage - 1) * config.limitData + 1
                : config.currentPage,
            keyword: value,
          };
          onReceiveActionProps("searchResult", obj1);
        } else if (value.length < 2 && type === "onRequestSearch") {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Required Minimum 2 Characters",
            }),
          );
        } else if (value === "") {
          onReceiveActionProps("cancelSearchResult", null);
        }
      } else {
        const rawData = JSON.parse(tableRawData);
        let data = [];
        if (value.length >= 2) {
          if (rawData[0]?.documentType) {
            data = rawData.filter((x) =>
              ["name"].some((k) =>
                String(x[k]).toLowerCase().includes(value.toLowerCase()),
              ),
            );
          } else if (rawData[0]?.sourcedFrom) {
            data = rawData?.filter((x) =>
              [
                "applicantCode",
                "firstName",
                "lastName",
                "contactNumber",
                "jobCode",
                "jobTitle",
              ].some((k) =>
                String(x[k]).toLowerCase().includes(value.toLowerCase()),
              ),
            );
          } else if (rawData[0]?.projectCode) {
            data = rawData.filter((x) =>
              ["name"].some((k) =>
                String(x[k]).toLowerCase().includes(value.toLowerCase()),
              ),
            );
            onReceiveActionProps("keyword", value);
          } else {
            data = rawData.filter((x) =>
              Object.keys(x).some((k) =>
                String(x[k]).toLowerCase().includes(value.toLowerCase()),
              ),
            );
          }
          if (data.length > 0) {
            setTotalRecords(
              config.isPagingServer === false
                ? Math.ceil(data.length / config.limitData)
                : data.length,
            );
            setTotalRecordsCount(data.length);
            if (data.length > usersPerPage) {
              setTableData(
                data.slice(
                  (config.currentPage - 1) * usersPerPage,
                  config.currentPage * usersPerPage,
                ),
              );
            } else {
              setTableData(data);
            }
          } else {
            setTableData([]);
            setTotalRecords(0);
            setTotalRecordsCount(0);
          }
        } else if (value.length < 2 && type === "onRequestSearch") {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Required Minimum 2 Characters",
            }),
          );
        } else {
          setTableData(rawData);
          setTotalRecords(rawData.length);
          setTotalRecordsCount(rawData.length);
        }
      }
    } else if (value === "" && config.isSearchServer === true) {
      onReceiveActionProps("cancelSearchResult", null);
    } else if (value === "" && config.isSearchServer === false) {
      onReceiveActionProps("cancelSearchResult", null);
      setSearchValue("");
      let rawData = JSON.parse(tableRawData);
      setTableData(rawData);
      setTotalRecords(rawData.length);
      setTotalRecordsCount(config.totalRecordsCount);
    }
  };

  const onMultipleActionHandler = (type) => {
    const updatedData = tableData?.map((item) => ({
      ...item,
      isChecked: item.id === selectedRowData.id,
    }));
    setTableData(updatedData);
    onSelectActionHandler(type, updatedData);
    setAnchorMuiltipleActionEl(null);
  };

  const onSelectActionHandler = (type, data = tableData) => {
    setAction(type);
    if (type === "Delete") {
      setOpen(false);
      if (data.length > 0) {
        let getData = data.filter((user) => user.isChecked === true);
        if (getData.length > 0) {
          setWarningPopupDetails(warningPopupEnum.DELETE);
          setOpen(true);
          setDeleteId(getData);
        } else {
          dispatch(
            updateSnackbar({ type: "error", message: "No record selected" }),
          );
        }
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 100);
    } else if (
      type === "All Applicants" ||
      type === "ATS Applicants" ||
      type === "Job Portal Applicants" ||
      type === "Associate Applicants"
    ) {
      setAction(type);
      setOpen(false);
      onReceiveActionProps(type, null);
    } else if (type === "Associate Applicant" || type === "Remove Applicants") {
      setAction(type);
      setOpen(false);
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      }
    } else if (type === "Download") {
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      }
    } else if (
      type === "Accept" ||
      type === "Reject" ||
      type === "Mark as Primary"
    ) {
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 200);
    } else if (
      type === "Send E-mail" ||
      type === "Send SMS" ||
      type === "Send E-mail to client"
    ) {
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
      // onReceiveActionProps(type, true);
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 100);
    } else if (type === "Update Status" || type === "Add to Project") {
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 100);
    } else if (type === "New Document") {
      onReceiveActionProps(type, null);
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 100);
    } else if (type === "Clone") {
      let getData = data.filter((user) => user.isChecked === true);
      if (getData.length === 1) {
        setWarningPopupDetails(warningPopupEnum.CLONE);
        setOpen(true);
      } else {
        setAction(defaultActionLabel);
        if (getData.length > 1) {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Please select only one job for cloning.",
            }),
          );
        } else {
          dispatch(
            updateSnackbar({
              type: "error",
              message: "Please select a job to clone.",
            }),
          );
        }
      }
    } else if (type === "Reactivate" || type === "Deactivate") {
      if (data.length > 0) {
        let getData = data.filter((user) => user.isChecked === true);
        if (getData.length > 0) {
          setWarningPopupDetails(
            type === "Deactivate"
              ? warningPopupEnum.DEACTIVATE
              : warningPopupEnum.REACTIVATE,
          );
          setOpen(true);
          setDeleteId(getData);
        } else {
          dispatch(
            updateSnackbar({ type: "error", message: "No record selected" }),
          );
        }
      }
      setTimeout(() => {
        setAction(defaultActionLabel);
      }, 100);
    } else if (["All Clients", "Pilot", "Active", "Inactive"].includes(type)) {
      onReceiveActionProps(type, null);
    }
  };

  const handleActionClick = (obj, type, HandlerType) => {
    if (type === "edit") {
      // dispatch(updateJobCode(obj));
      let Name = obj.jobTitle
        ? `${obj.jobTitle} (${obj.jobCode})`
        : obj.firstName || obj.lastName
          ? `${obj.firstName} ${obj.lastName}`
          : obj.clientName
            ? obj.clientName
            : obj.name;
      let additionalData = {};
      if (obj.type === "Applicant Code") {
        let workExpObj = JSON.parse(obj.workExp) || [];
        let designation =
          workExpObj?.length > 0
            ? `${workExpObj[0]?.jobTitle || ""}${
                workExpObj[0]?.organization
                  ? " / " + workExpObj[0]?.organization
                  : ""
              }`
            : "";
        additionalData["applicantName"] =
          obj.ApplicantName || obj.firstName + " " + obj.lastName;
        let expObject = workExpObj[0]?.experienceInMonths
          ? workExpObj[0]?.experienceInMonths
          : {
              startDate: workExpObj[0]?.startDate,
              endDate: Boolean(workExpObj[0]?.isCurrent)
                ? "present"
                : workExpObj[0]?.endDate,
            };
        additionalData["currentWorking"] = {
          designation: designation,
          from: getWorkonDate(expObject, "level2"),
        };
        additionalData["emailId"] = obj?.emailId;
        additionalData["contactNumber"] = obj?.contactNumber;
        additionalData["alternateContactNumber"] = obj?.alternateContactNumber;
        additionalData["linkedIn"] = obj?.linkedIn ?? "";
        additionalData["address"] = obj?.address ?? "test address";
      }
      if (obj.type === "Job Code") {
        additionalData["jobStatus"] = obj?.jobStatus || "";
        additionalData["lastUpdated"] = GetTimeZone(obj?.updatedAt) || "";
        additionalData["jobType"] = obj?.jobType
          ? obj?.jobType.replace(/,/g, ", ")
          : "";
        additionalData["workModel"] = obj?.workModel || "";
        additionalData["jobLocation"] = obj.location || "";
        additionalData["experience"] = obj?.experience || "";
        additionalData["segment"] = obj?.segmentId || "";
        additionalData["segmentName"] = obj?.segmentName || "";
        additionalData["priority"] = obj?.priority || "";
      }
      let newobj = { id: obj.id, name: Name, type: obj.type, additionalData };
      let subPathObj = JSON.parse(localStorage.getItem("subpathObj"));
      if (subPathObj && subPathObj.length > 0) {
        let index = subPathObj.findIndex((x) => x.id === newobj.id);
        if (index !== -1) {
          subPathObj[index] = newobj;
        } else {
          subPathObj.push(newobj);
        }
      } else {
        subPathObj = [newobj];
      }
      if (obj.nagigate !== "detailspage") {
        localStorage.setItem("subpathObj", JSON.stringify(subPathObj));
        onReceiveActionProps("detailspage", obj);

        // navigate(`${obj.nagigate}/${obj.id}`);
      } else {
        onReceiveActionProps("detailspage", obj);
      }
    } else if (type === "delete") {
      setWarningPopupDetails(warningPopupEnum.DELETE);
      setOpen(true);
      setDeleteId(obj);
    } else if (type === "confirmDel" && deleteId !== null) {
      setOpen(false);
      onReceiveActionProps(type, deleteId);
    } else if (type === "download") {
      onReceiveActionProps(type, obj);
    } else if (type === "pagination" && config.isPagingServer === true) {
      let obj1 = {
        current: obj,
        offset: obj !== 1 ? (obj - 1) * config.limitData + 1 : 1, //obj
        limit: config.limitData,
      };
      onReceiveActionProps(type, obj1);
    } else if (type === "pagination" && config.isPagingServer === false) {
      config.currentPage = obj;
      if (!searchValue) {
        let DataNew = JSON.parse(tableRawData);
        const modifyData = DataNew.map((item) => {
          item.isChecked = false;
          return item;
        });
        onReceiveActionProps("scroll", obj);
        setChecked(false);
        setTableData(
          modifyData.slice((obj - 1) * usersPerPage, obj * usersPerPage),
        );
      } else if (
        searchValue &&
        searchValue?.length >= 2 &&
        searchValue !== ""
      ) {
        onSearchhandler(searchValue, "onRequestSearch");
      }
    } else if (
      type === "view" ||
      type === "viewDocumentNewPage" ||
      type === "viewAnswers" ||
      type === "pageRange" ||
      type === "associateApplicant"
    ) {
      onReceiveActionProps(type, obj);
    } else if (type === "confirmClone") {
      setOpen(false);
      let getData = tableData?.filter((user) => user.isChecked === true);
      if (getData.length > 0) {
        onReceiveActionProps(type, getData);
      }
    } else if (
      (type === "deactivate" || type === "reactivate") &&
      deleteId !== null
    ) {
      setOpen(false);
      onReceiveActionProps(type, deleteId);
    }
  };

  const onChangeHandler = (value, rowData, type) => {
    if (type === "associatejobStatus") {
      // setAssociateDropdown(value);
      if (tableData.length > 0) {
        let findIndex = tableData.findIndex(
          (user) => user.jobCode === rowData.jobCode,
        );
        if (findIndex !== -1) {
          tableData[findIndex].associatejobStatus = value;
        }
        setTableData(tableData);
        onReceiveActionProps(type, tableData[findIndex]);
      }
    }
  };

  return (
    <>
      {config.isDropdownActions || config.isSearchbar ? (
        <div
          className={
            config.isDropdownActions &&
            config.isSearchbar &&
            addModel?.displayName == ""
              ? "actionSectionAssoc"
              : !config.isDropdownActions &&
                  addModel?.displayName == "" &&
                  !config.isCheckbox
                ? "actionSectionAssocReject"
                : "actionSection"
          }
        >
          <div className="actionDropdowncss">
            <FormControl className="actionDrop">
              {config.isDropdownActions ? (
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className="actionDropdown"
                  value={action}
                  label=""
                  onChange={(e) => onSelectActionHandler(e.target.value)}
                >
                  {actionDropdown.map((list, i) => (
                    <MenuItem
                      style={{
                        display: "grid",
                        justifyContent: "left",
                        padding: "2px 30px",
                        cursor: "pointer",
                        width: "190px",
                      }}
                      key={i}
                      value={list}
                    >
                      {list}
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                ""
              )}
            </FormControl>
          </div>
          <div className="searchdivcss">
            {config.isSearchbar ? (
              <SearchBar
                className="SearchBar"
                autoFocus
                autocomplete="off"
                onChange={(newValue) => onSearchhandler(newValue, "onChange")}
                onRequestSearch={(newValue) =>
                  onSearchhandler(newValue, "onRequestSearch")
                }
                onCancelSearch={() => onSearchhandler("", "onCancelSearch")}
                placeholder={searchKeyWord}
                value={searchValue}
              />
            ) : (
              ""
            )}
          </div>
          <div className="addcomponent">
            {addModel?.displayName && (
              <div
                className="addicon"
                style={{ marginBottom: "15px", marginLeft: "47px" }}
                onClick={() =>
                  addModel.url !== ""
                    ? navigate(addModel.url)
                    : onReceiveActionProps("newApplicants", true)
                }
              >
                <DashboardPlusicon width={35} height={36} />
                <h4
                  style={{
                    marginLeft: "9px",
                    marginLeft: "9px",
                    fontFamily: "Roboto",
                    fontWeight: "400",
                    fontSize: "18px",
                    color: "#3B4046",
                  }}
                >
                  {" "}
                  {addModel.displayName}
                </h4>
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      {Array.isArray(tableData) &&
        tableData.filter((x) => x.isChecked === true).length > 0 && (
          <div
            className="outside-delete-button"
            onClick={(e) => {
              onSelectActionHandler("Delete");
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assests/img/newTrash.svg"}
              alt="new delete icon"
            />
            Delete
          </div>
        )}
      {Boolean(config.isTotalCount) && (
        <p id="total-record-count-text" style={{ float: "left" }}>
          <b>{config.totalRecordsCountText}</b> - {totalRecordsCount}
        </p>
      )}
      <TableContainer component={Paper} sx={{ maxHeight: tableMaxheight }}>
        <Table
          sx={{ minWidth: 700 }}
          aria-label="customized table"
          className="customizedTable"
          // stickyHeader
        >
          <TableHead>
            <TableRow>
              {config.isCheckbox ? (
                <StyledTableCell
                  style={{ width: 50 }}
                  className={config.ischeckAlignRight ? "col-align-right" : ""}
                >
                  {tableData.length !== 0 && (
                    <Checkbox
                      style={{ width: "42px" }}
                      checked={checked ? true : false}
                      onChange={handleChange}
                      indeterminate={isInterminate}
                    />
                  )}
                </StyledTableCell>
              ) : (
                ""
              )}
              {colmns.map((list, k) => {
                // eslint-disable-next-line
                if (
                  list.displayName !== "Action" &&
                  list.mappingName !== "screeningquestions" &&
                  list.displayName !== "primaryResume"
                ) {
                  return (
                    <StyledTableCell
                      key={k}
                      className={list.theadClass}
                      width={list.width}
                    >
                      {list.mappingName === " " ? (
                        <>
                          {" "}
                          {list.displayName}
                          <FilterListIcon
                            fontSize="small"
                            style={{
                              verticalAlign: "text-top",
                              marginLeft: "12px",
                              cursor: "pointer",
                            }}
                            onClick={handleClick}
                          />
                          <Menu
                            anchorEl={anchorEl}
                            className="filterMenuList"
                            open={filteropen}
                            onClose={handlefilterClose}
                          >
                            <MenuItem
                              onClick={(e) =>
                                onSelectActionHandler("All Applicants")
                              }
                            >
                              All Applicants
                            </MenuItem>
                            <MenuItem
                              onClick={(e) =>
                                onSelectActionHandler("ATS Applicants")
                              }
                            >
                              ATS Applicants
                            </MenuItem>
                            <MenuItem
                              onClick={(e) =>
                                onSelectActionHandler("Job Portal Applicants")
                              }
                            >
                              Job Portal Applicants
                            </MenuItem>
                          </Menu>
                        </>
                      ) : (
                        list.displayName
                      )}
                    </StyledTableCell>
                  );
                } else if (list.mappingName === "screeningquestions") {
                  return (
                    <StyledTableCell key={k} className={list.theadClass}>
                      {list.displayName}
                    </StyledTableCell>
                  );
                } else if (config.isActions && list.displayName === "Action") {
                  return (
                    <StyledTableCell key={k} className={list.theadClass}>
                      {list.displayName}
                    </StyledTableCell>
                  );
                }
              })}
            </TableRow>
          </TableHead>
          {typeof tableData !== "string" && tableData.length > 0 && (
            <TableBody>
              {tableData.map((rowData, i) => (
                <StyledTableRow key={i}>
                  {config.isCheckbox ? (
                    <StyledTableCell
                      component="th"
                      scope="row"
                      key={i}
                      className={
                        config.ischeckAlignRight ? "col-align-right" : ""
                      }
                    >
                      <Checkbox
                        style={{ width: "42px", color: "#00000099" }}
                        checked={rowData.isChecked ? true : false}
                        onChange={(e) => onCheckedHandler(e, rowData)}
                      />
                    </StyledTableCell>
                  ) : (
                    ""
                  )}
                  {colmns.map((list, j) => {
                    if (
                      list.displayName !== "Action" &&
                      list.isEdit === true &&
                      list.mappingName !== "screeningquestions"
                    ) {
                      return (
                        <StyledTableCell
                          className={`${list.tbodyClass} activeRow`}
                          width={list.width}
                          key={j}
                        >
                          <span
                            onClick={() =>
                              handleActionClick({ ...list, ...rowData }, "edit")
                            }
                          >
                            {list.nagigate !== "detailspage" &&
                            list.nagigate !== "countrywithflag" ? (
                              <>
                                <a
                                  className="rm-link"
                                  href={`${list.nagigate}/${rowData.id}`}
                                  onContextMenu={() =>
                                    handleActionClick(
                                      { ...list, ...rowData },
                                      "edit",
                                    )
                                  }
                                >
                                  {rowData[list.mappingName]}
                                </a>
                                {list?.openNewTab === true && (
                                  <a
                                    className="rm-link"
                                    href={`${list.nagigate}/${rowData.id}`}
                                    target="_blank"
                                  >
                                    <img
                                      src={`${process.env.PUBLIC_URL}/assests/img/newtabIcon.svg`}
                                      alt="new tab icon"
                                      style={{
                                        width: "12px",
                                        marginLeft: "8px",
                                      }}
                                    />
                                  </a>
                                )}
                              </>
                            ) : list.nagigate === "countrywithflag" ? (
                              <a
                                className="rm-link countryclass"
                                onContextMenu={() =>
                                  handleActionClick(
                                    { ...list, ...rowData },
                                    "edit",
                                  )
                                }
                              >
                                {rowData[list.mappingName]}
                                <img
                                  src={`${process.env.REACT_APP_IMG_BASEPATH}/${rowData.countryLogo}`}
                                  alt=""
                                  className="countryflag"
                                />
                              </a>
                            ) : (
                              rowData[list.mappingName]
                            )}
                          </span>
                        </StyledTableCell>
                      );
                    } else if (
                      list.displayName !== "Action" &&
                      list.mappingName !== "documentType" &&
                      list.mappingName !== "documentName" &&
                      list.mappingName !== "primaryResume" &&
                      list.isEdit !== true &&
                      list.mappingName !== "screeningquestions" &&
                      list.mappingName !== "percentage" &&
                      list.mappingName !== "associatejobStatus"
                    ) {
                      return (
                        <StyledTableCell
                          className={list.tbodyClass}
                          width={list.width}
                          key={j}
                          // style={{ cursor: "pointer" }}
                        >
                          {list.displayName === "Applicant ID" ? (
                            <span>{rowData[list.mappingName]}</span>
                          ) : rowData["primaryResume"] === 1 &&
                            list.displayName === "Document Name" ? (
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {rowData[list.mappingName]}
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assests/img/star-inside-circle.svg"
                                }
                                alt={rowData[list.mappingName]}
                                style={{
                                  padding: "0px 0px 0px 5px",
                                  margin: "0px",
                                }}
                              />
                            </span>
                          ) : list.mappingName === "mulitpleAction" ? (
                            <>
                              <Button
                                variant="icon"
                                className="viewicon"
                                onClick={() =>
                                  handleActionClick(rowData, "view")
                                }
                              >
                                <svg
                                  id="Component_160_2"
                                  data-name="Component 160 – 2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21.485"
                                  height="23.966"
                                  viewBox="0 0 21.485 23.966"
                                >
                                  <path
                                    id="file"
                                    d="M8.8,23.03a.936.936,0,0,1-.936.936H3.745A3.749,3.749,0,0,1,0,20.222V3.745A3.749,3.749,0,0,1,3.745,0h11.51A3.749,3.749,0,0,1,19,3.745v8.941a.936.936,0,0,1-1.872,0V3.745a1.875,1.875,0,0,0-1.872-1.872H3.745A1.875,1.875,0,0,0,1.872,3.745V20.222a1.875,1.875,0,0,0,1.872,1.872H7.864A.936.936,0,0,1,8.8,23.03ZM14.318,5.617H4.676a.936.936,0,1,0,0,1.872h9.643a.936.936,0,0,0,0-1.872Zm.936,4.681a.936.936,0,0,0-.936-.936H4.676a.936.936,0,1,0,0,1.872h9.643A.936.936,0,0,0,15.255,10.3ZM4.676,13.107a.936.936,0,1,0,0,1.872H9.6a.936.936,0,1,0,0-1.872Zm16.639,6.857c-.033.047-.146.207-.216.295a13.174,13.174,0,0,1-2.069,2.133,6.42,6.42,0,0,1-4,1.575,6.42,6.42,0,0,1-4-1.575,13.17,13.17,0,0,1-2.069-2.133c-.07-.088-.183-.248-.216-.295a.936.936,0,0,1,0-1.076c.033-.047.146-.207.216-.295a13.171,13.171,0,0,1,2.069-2.132,6.42,6.42,0,0,1,4-1.575,6.42,6.42,0,0,1,4,1.575A13.17,13.17,0,0,1,21.1,18.593c.07.088.183.248.216.295A.936.936,0,0,1,21.315,19.964Zm-1.953-.538c-1.489-1.771-2.946-2.668-4.337-2.668s-2.848.9-4.337,2.668c1.489,1.771,2.946,2.668,4.337,2.668S17.874,21.2,19.362,19.426Zm-4.29-1.779a1.779,1.779,0,1,0,1.779,1.779A1.779,1.779,0,0,0,15.073,17.647Zm0,0"
                                    fill="#3b4046"
                                  />
                                </svg>
                              </Button>
                              <Button
                                variant="icon"
                                className="documentdownloadicon"
                                onClick={() =>
                                  handleActionClick(rowData, "download")
                                }
                              >
                                <svg
                                  id="surface1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21.617"
                                  height="23.966"
                                  viewBox="0 0 21.617 23.966"
                                >
                                  <path
                                    id="Path_24419"
                                    data-name="Path 24419"
                                    d="M237.853,18.217H240.5l-4.049-4.26v2.851A1.409,1.409,0,0,0,237.853,18.217Zm0,0"
                                    transform="translate(-225.381 -13.304)"
                                    fill="#3b4046"
                                  />
                                  <path
                                    id="Path_24420"
                                    data-name="Path 24420"
                                    d="M192.612,236.336a6.452,6.452,0,1,0,6.452,6.452A6.458,6.458,0,0,0,192.612,236.336Zm3.466,7-3.164,3.4a.432.432,0,0,1-.319.135.42.42,0,0,1-.313-.135l-3.158-3.4a.434.434,0,0,1,.022-.61.44.44,0,0,1,.615.022l2.419,2.591V239.17a.432.432,0,0,1,.864,0v6.171l2.408-2.591a.43.43,0,1,1,.626.589Zm0,0"
                                    transform="translate(-177.446 -225.273)"
                                    fill="#3b4046"
                                  />
                                  <path
                                    id="Path_24421"
                                    data-name="Path 24421"
                                    d="M8.082,15.657H3.39a.432.432,0,1,1,0-.864H8.368a7.669,7.669,0,0,1,1.1-1.89H3.39a.432.432,0,0,1,0-.864h6.895a7.433,7.433,0,0,1,4.886-1.857c.178,0,.324.016.54.032V5.777H12.471A2.275,2.275,0,0,1,10.2,3.5V0H1.922A1.932,1.932,0,0,0,0,1.949V18.427a1.914,1.914,0,0,0,1.922,1.927H8.428a7.374,7.374,0,0,1-.345-4.7ZM3.39,9.34H8.86a.432.432,0,0,1,0,.864H3.39a.432.432,0,0,1,0-.864Zm0,0"
                                    fill="#3b4046"
                                  />
                                </svg>
                              </Button>
                              <IconButton
                                size="small"
                                style={{ position: "relative" }}
                                onClick={(e) => {
                                  setAnchorMuiltipleActionEl(e.currentTarget);
                                  setSelectedRowData(rowData);
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                anchorEl={anchorMuiltipleActionEl}
                                open={Boolean(anchorMuiltipleActionEl)}
                                onClose={() => setAnchorMuiltipleActionEl(null)}
                                disablePortal
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                transformOrigin={{
                                  vertical: "top",
                                  horizontal: "right",
                                }}
                                PaperProps={{
                                  elevation: 2,
                                  sx: {
                                    borderRadius: 2,
                                    minWidth: 180,
                                  },
                                }}
                              >
                                <MenuItem
                                  onClick={() => {
                                    onMultipleActionHandler("Mark as Primary");
                                  }}
                                >
                                  <ListItemIcon>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assests/img/star-inside-circle.svg"
                                      }
                                      alt={rowData[list.mappingName]}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary="Mark as Primary"
                                    sx={{ textAlign: "left" }}
                                  />
                                </MenuItem>
                                <MenuItem
                                  onClick={() => {
                                    onMultipleActionHandler("Delete");
                                  }}
                                >
                                  <ListItemIcon>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assests/img/newTrash.svg"
                                      }
                                      alt={rowData[list.mappingName]}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary="Delete Document"
                                    sx={{ textAlign: "left" }}
                                  />
                                </MenuItem>

                                <MenuItem
                                  onClick={() => {
                                    setAnchorMuiltipleActionEl(null);
                                    onReceiveActionProps(
                                      "viewDocumentNewPage",
                                      rowData,
                                    );
                                  }}
                                >
                                  <ListItemIcon>
                                    <OpenInNewIcon
                                      fontSize="small"
                                      sx={{ color: "black" }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary="Preview"
                                    sx={{ textAlign: "left" }}
                                  />
                                </MenuItem>
                              </Menu>
                            </>
                          ) : (
                            <span
                              className={
                                list?.isClassDynamic
                                  ? rowData[list.mappingName] === "Duplicate"
                                    ? "duplicate-class"
                                    : rowData[list.mappingName] === "Success"
                                      ? "success-class"
                                      : rowData[list.mappingName] === "Failed"
                                        ? "failed-class"
                                        : ""
                                  : ""
                              }
                            >
                              {rowData[list.mappingName]}
                              {list?.isClassDynamic &&
                                rowData[list.mappingName] === "Failed" && (
                                  <>
                                    &nbsp; <InfoIcon width={15} height={15} />
                                  </>
                                )}
                            </span>
                          )}
                        </StyledTableCell>
                      );
                    } else if (list.mappingName === "screeningquestions") {
                      return (
                        <StyledTableCell
                          className="screeningQuestionsCountAlign"
                          key={j}
                          width={list.width}
                          onClick={() =>
                            handleActionClick(rowData, "viewAnswers")
                          }
                        >
                          {rowData[list.mappingName]}
                          {rowData[list.mappingName] &&
                            !rowData[list.mappingName].startsWith("0/") && (
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assests/viewIcon.svg"
                                }
                                width={17}
                                alt={rowData[list.mappingName]}
                              />
                            )}
                        </StyledTableCell>
                      );
                    } else if (
                      config.isActions &&
                      list.displayName === "Action"
                    ) {
                      return (
                        <StyledTableCell
                          className={list.tbodyClass}
                          key={j}
                          width={list.width}
                        >
                          <div className="postingdocumentsicons">
                            {actions.isDownload ? (
                              <Button
                                variant="icon"
                                className="downloadicon"
                                style={{ marginRight: "10px" }}
                                onClick={() =>
                                  handleActionClick(rowData, "download")
                                }
                              >
                                <SaveAltIcon />
                              </Button>
                            ) : (
                              ""
                            )}

                            {actions.isPositingsView ? (
                              <Button
                                variant="icon"
                                className="viewicon"
                                onClick={() =>
                                  handleActionClick(rowData, "view")
                                }
                              >
                                <svg
                                  id="Component_160_2"
                                  data-name="Component 160 – 2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21.485"
                                  height="23.966"
                                  viewBox="0 0 21.485 23.966"
                                >
                                  <path
                                    id="file"
                                    d="M8.8,23.03a.936.936,0,0,1-.936.936H3.745A3.749,3.749,0,0,1,0,20.222V3.745A3.749,3.749,0,0,1,3.745,0h11.51A3.749,3.749,0,0,1,19,3.745v8.941a.936.936,0,0,1-1.872,0V3.745a1.875,1.875,0,0,0-1.872-1.872H3.745A1.875,1.875,0,0,0,1.872,3.745V20.222a1.875,1.875,0,0,0,1.872,1.872H7.864A.936.936,0,0,1,8.8,23.03ZM14.318,5.617H4.676a.936.936,0,1,0,0,1.872h9.643a.936.936,0,0,0,0-1.872Zm.936,4.681a.936.936,0,0,0-.936-.936H4.676a.936.936,0,1,0,0,1.872h9.643A.936.936,0,0,0,15.255,10.3ZM4.676,13.107a.936.936,0,1,0,0,1.872H9.6a.936.936,0,1,0,0-1.872Zm16.639,6.857c-.033.047-.146.207-.216.295a13.174,13.174,0,0,1-2.069,2.133,6.42,6.42,0,0,1-4,1.575,6.42,6.42,0,0,1-4-1.575,13.17,13.17,0,0,1-2.069-2.133c-.07-.088-.183-.248-.216-.295a.936.936,0,0,1,0-1.076c.033-.047.146-.207.216-.295a13.171,13.171,0,0,1,2.069-2.132,6.42,6.42,0,0,1,4-1.575,6.42,6.42,0,0,1,4,1.575A13.17,13.17,0,0,1,21.1,18.593c.07.088.183.248.216.295A.936.936,0,0,1,21.315,19.964Zm-1.953-.538c-1.489-1.771-2.946-2.668-4.337-2.668s-2.848.9-4.337,2.668c1.489,1.771,2.946,2.668,4.337,2.668S17.874,21.2,19.362,19.426Zm-4.29-1.779a1.779,1.779,0,1,0,1.779,1.779A1.779,1.779,0,0,0,15.073,17.647Zm0,0"
                                    fill="#3b4046"
                                  />
                                </svg>
                              </Button>
                            ) : (
                              ""
                            )}
                            {actions.isPostingsDownload ? (
                              <Button
                                variant="icon"
                                className="documentdownloadicon"
                                onClick={() =>
                                  handleActionClick(rowData, "download")
                                }
                              >
                                <svg
                                  id="surface1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21.617"
                                  height="23.966"
                                  viewBox="0 0 21.617 23.966"
                                >
                                  <path
                                    id="Path_24419"
                                    data-name="Path 24419"
                                    d="M237.853,18.217H240.5l-4.049-4.26v2.851A1.409,1.409,0,0,0,237.853,18.217Zm0,0"
                                    transform="translate(-225.381 -13.304)"
                                    fill="#3b4046"
                                  />
                                  <path
                                    id="Path_24420"
                                    data-name="Path 24420"
                                    d="M192.612,236.336a6.452,6.452,0,1,0,6.452,6.452A6.458,6.458,0,0,0,192.612,236.336Zm3.466,7-3.164,3.4a.432.432,0,0,1-.319.135.42.42,0,0,1-.313-.135l-3.158-3.4a.434.434,0,0,1,.022-.61.44.44,0,0,1,.615.022l2.419,2.591V239.17a.432.432,0,0,1,.864,0v6.171l2.408-2.591a.43.43,0,1,1,.626.589Zm0,0"
                                    transform="translate(-177.446 -225.273)"
                                    fill="#3b4046"
                                  />
                                  <path
                                    id="Path_24421"
                                    data-name="Path 24421"
                                    d="M8.082,15.657H3.39a.432.432,0,1,1,0-.864H8.368a7.669,7.669,0,0,1,1.1-1.89H3.39a.432.432,0,0,1,0-.864h6.895a7.433,7.433,0,0,1,4.886-1.857c.178,0,.324.016.54.032V5.777H12.471A2.275,2.275,0,0,1,10.2,3.5V0H1.922A1.932,1.932,0,0,0,0,1.949V18.427a1.914,1.914,0,0,0,1.922,1.927H8.428a7.374,7.374,0,0,1-.345-4.7ZM3.39,9.34H8.86a.432.432,0,0,1,0,.864H3.39a.432.432,0,0,1,0-.864Zm0,0"
                                    fill="#3b4046"
                                  />
                                </svg>
                              </Button>
                            ) : (
                              ""
                            )}
                            {actions.isDelete ? (
                              <Button
                                variant="icon"
                                className="deleteicon"
                                onClick={() =>
                                  handleActionClick(rowData, "delete")
                                }
                              >
                                <DeleteIcon />
                              </Button>
                            ) : (
                              ""
                            )}
                            {actions.isRadiobtn ? (
                              <Button
                                className="checkCircleicon"
                                variant="icon"
                                onClick={() =>
                                  handleActionClick(
                                    rowData,
                                    "associateApplicant",
                                  )
                                }
                              >
                                {selectedId ===
                                  (rowData.id ? rowData.id : rowData.docsid) &&
                                selectedId !== "" ? (
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assests/radio.svg"
                                    }
                                    width={18}
                                    className="radiobtnActive"
                                    alt={""}
                                  />
                                ) : (
                                  <PanoramaFishEyeIcon />
                                )}
                              </Button>
                            ) : (
                              ""
                            )}
                            {actions?.openNewTab && (
                              <Button
                                className="newLinkicon"
                                variant="icon"
                                onClick={() =>
                                  handleActionClick(
                                    rowData,
                                    "viewDocumentNewPage",
                                  )
                                }
                              >
                                <OpenInNewIcon />
                              </Button>
                            )}
                          </div>
                        </StyledTableCell>
                      );
                    } else if (list.mappingName === "percentage") {
                      return (
                        <StyledTableCell
                          className={list.tbodyClass}
                          key={j}
                          width={list.width}
                        >
                          {list.mappingName === "percentage" &&
                          rowData[list.mappingName] !== "N/A" ? (
                            <div className="percentbar">
                              <BorderLinearProgress
                                className="progress"
                                variant="determinate"
                                value={rowData[list.mappingName]}
                              />
                              <p>{rowData[list.mappingName] + "%"}</p>
                            </div>
                          ) : (
                            <p>{rowData[list.mappingName]}</p>
                          )}
                        </StyledTableCell>
                      );
                    } else if (
                      config.isActions == true &&
                      list.mappingName === "associatejobStatus" &&
                      list.nagigate === null
                    ) {
                      return (
                        <StyledTableCell
                          className={list.tbodyClass}
                          key={j}
                          width={list.width}
                        >
                          {list.mappingName === "associatejobStatus" ? (
                            <div className="statusDropdown">
                              <Select
                                value={rowData[list.mappingName]}
                                size="small"
                                name="associatejobStatus"
                                autoComplete="off"
                                onChange={(e) =>
                                  onChangeHandler(
                                    e.target.value,
                                    rowData,
                                    "associatejobStatus",
                                  )
                                }
                                style={{
                                  width: "85%",
                                  borderRadius: "4px",
                                  textAlign: "left",
                                  paddingLeft: "4%",
                                }}
                              >
                                {statusValues.map((name) => (
                                  <MenuItem
                                    className="selectOptions"
                                    key={name}
                                    value={name}
                                  >
                                    {name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </div>
                          ) : (
                            ""
                          )}
                        </StyledTableCell>
                      );
                    } else if (
                      (config.isActions === false &&
                        list.mappingName === "documentName") ||
                      (config.isActions === true &&
                        list.mappingName === "documentType")
                    ) {
                      console.log(
                        rowData[list.mappingName],
                        "rowData[rowData.mappingName]",
                      );
                      return (
                        <StyledTableCell
                          className={list.tbodyClass}
                          key={j}
                          width={list.width}
                        >
                          {list.mappingName === "documentType" ||
                          (list.mappingName === "documentName" &&
                            rowData[list.mappingName]) ? (
                            <div className="documentTypecss">
                              {rowData["fileType"] === "pdf" &&
                              !list.tbodyClass.includes("hide") ? (
                                <img
                                  src={`${process.env.PUBLIC_URL}/assests/img/${list.tbodyClass.includes("newIcons") ? "newPdf.svg" : "pdf.svg"}`}
                                  alt=""
                                  className="pdficon"
                                />
                              ) : (
                                <img
                                  src={`${process.env.PUBLIC_URL}/assests/img/${list.tbodyClass.includes("newIcons") ? "newDocment.svg" : "docx.svg"}`}
                                  alt=""
                                  className="pdficon"
                                />
                              )}
                              <p>
                                {rowData[list.mappingName]}
                                {rowData.primaryResume === 1 && (
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assests/img/star-inside-circle.svg"
                                    }
                                    alt={rowData[list.mappingName]}
                                    style={{
                                      paddingLeft: "5px",
                                      verticalAlign: "bottom",
                                    }}
                                  />
                                )}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                        </StyledTableCell>
                      );
                    }
                  })}
                </StyledTableRow>
              ))}
            </TableBody>
          )}
          {isTableLoading &&
            typeof tableData !== "string" &&
            tableData.length === 0 && (
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell
                    colSpan={
                      config.isCheckbox ? colmns.length + 1 : colmns.length
                    }
                  ></StyledTableCell>
                </StyledTableRow>
              </TableBody>
            )}
          {showNoData && (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell
                  colSpan={
                    config.isCheckbox ? colmns.length + 1 : colmns.length
                  }
                >
                  <div className="nodatasection">
                    <img
                      src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                      alt="noData"
                    />
                    {noDataText}
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          )}
          {typeof tableData === "string" && !showNoData && (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell
                  colSpan={
                    config.isCheckbox ? colmns.length + 1 : colmns.length
                  }
                >
                  {!isTableLoading && (
                    <div className="nodatasection">
                      <img
                        src={process.env.PUBLIC_URL + "/assests/NoResult.svg"}
                        alt="noResult"
                      />
                      {noDataText || "No Match Found"}
                    </div>
                  )}
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <div className="pagingRight">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage ? currentPage : 0}
          totalCount={totalRecords}
          pageSize={usersPerPage}
          onPageChange={(page) => handleActionClick(page, "pagination")}
        />
        {config.isPageRange ? (
          <Select
            id="demo-simple-select"
            onChange={(e) =>
              handleActionClick(Number(e.target.value), "pageRange")
            }
            value={config.limitData}
            className="selectData"
          >
            <MenuItem className="selectOptions" value="10">
              10
            </MenuItem>
            <MenuItem className="selectOptions" value="20">
              20
            </MenuItem>
            <MenuItem className="selectOptions" value="50">
              50
            </MenuItem>
          </Select>
        ) : (
          ""
        )}
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog"
        style={{ marginTop: "-26%" }}
      >
        <Box sx={{ width: "395px" }}>
          <DialogTitle className="diabtn">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText className="diabtnjob" id="alert-dialog">
              <p className="btntext">{warningPopupDetails.title}</p>
            </DialogContentText>
          </DialogContent>
          <DialogActions
            className={
              warningPopupDetails.type === "confirmClone"
                ? "warning-actionbtns"
                : "alert-actionbtns"
            }
          >
            <Button onClick={handleClose}>
              <Link
                href="#"
                color="#000"
                underline="always"
                sx={{ marginLeft: "10px" }}
              >
                Cancel
              </Link>
            </Button>
            <Button
              onClick={() => handleActionClick(null, warningPopupDetails.type)}
            >
              {warningPopupDetails.btnName}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default React.memo(DynamicTable);

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    paddingTop: "14px",
    paddingBottom: "14px",
    borderRight: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingTop: "11px",
    paddingBottom: "11px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // "&:last-child td": {
  //   borderRight: "1px solid #E8E8E8",
  // },
}));
